// extracted by mini-css-extract-plugin
export default {"root":"ScrollControls_root__By4Jv","scrollButton":"ScrollControls_scrollButton__THj00","dark":"ScrollControls_dark__hDVR-"};